<template>
    <div class="ur-tab__label" :class="labelClass" @click="clickLabel" >
        <div class="ur-tab__label-slot"  v-ur-tooltip:overflow="vTooltip">
            <ur-icon v-if="icon" :icon="icon"/><slot/>
        </div>
        <slot name="icon"></slot>
    </div>
</template>

<script>
// ur-tab-label는 tab contents의 index 역할을 합니다
// #ur-tab-label serves as an index for tab contents
export default {
    name:"urTabLabel",
    inject:['tabBox'],
    props:{
        // $ver: v0.1.0
        // 탭 컨텐츠의 index입니다.
        // #This is index of tab contents.
        // $default: null
        // $tags IDE, idx
        idx:[String,Number],
        // $ver: v0.1.0
        // 탭 라벨 영역에 붙일 아이콘 입니다.
        // #Icon name for tab label area.
        // $tags IDE, icon
        icon: {type: String, default: ''},
        // $ver: v0.2.1
        // 해당 탭을 비 활성화 시킬때 사용합니다.
        // #It can be used when disable this.
        disable: {type: Boolean},
        // $ver: v0.2.1
        // 별도의 툴팁이 필요한경우 명시합니다.
        // #If you want to specific tooltip? enter it.
        tooltip: {type: String, default:null},
        // $hide
        iconPos: {type: String, default: ''},
    },
    computed: {
        vTooltip() {
            // case 1. props toolitp
            if(this.tooltip) {
                return this.tooltip;
            }
            // case 1. default case
            if(this.$slots.default) {
                return this.$slots.default[0].text;
            }
            return '';
        },
        isActive() { return this.idx === this.tabBox.currIdx },
        labelClass() {
            let clazz = [];
            if(this.tabBox.shape === 'underline'){
                clazz.push("ur-tab__label-underline");
            } else if (this.tabBox.shape === 'none'){
                clazz.push("ur-tab__label-none");
            }
            if(this.tabBox.size === 'small') {
                clazz.push("ur-tab__label--mini");
            }
            if(this.disable) {
                clazz.push('ur-tab__label--disable');
            } else if(this.isActive) {
                clazz.push("ur-tab__label--active");
                if(this.tabBox.underline) {
                    clazz.push("ur-tab__label-underline--active")
                }
            }
            return clazz;
        },
    },
    methods: {
        clickLabel(e) {
            // 1. Do nothing when disabled on
            if(this.disable) return;
            
            this.tabBox.setIdx(this.idx);
            // $ver: v0.1.0
            // $arg: index of tab
            // 탭이 클릭 되었을때 발생합니다.
            // #It fires when tab is clicked.
            this.$emit("click",e);
        }
    }
}
</script>
